var t = ["top-left", "top-center", "top-right", "middle-left", "center", "middle-right", "bottom-left", "bottom-center", "bottom-right"],
    e = ["miter", "round", "bevel"],
    o = ["butt", "round", "square"],
    r = ["solid", "dashed"];
export { t as Anchors, o as LineCaps, e as LineJoins, r as StrokeStyles };